import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42bb3be0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gift-item" }
const _hoisted_2 = { class: "gift-item__title text-black text-size-18 text-weight-600" }
const _hoisted_3 = { class: "d-flex align-items-end justify-content-between mt-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-12" }, "使用ポイント", -1))
const _hoisted_5 = { class: "text-size-18 text-weight-600" }

import AppButton from "@/components/atoms/button/AppButton.vue";
import { computed } from "vue";
import { Gift } from "@/types/Gift";
import { formatNumber } from "@/utils/number";
import { authStore } from "@/store/auth";


export default /*#__PURE__*/_defineComponent({
  __name: 'PointCouponCard',
  props: {
    gift: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }) {

const props = __props;




const canExchange = computed(() => {
  return authStore.user!.caisukePoint >= props.gift.requiredPoint;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.gift.giftName), 1)
    ]),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _hoisted_4,
        _createTextVNode(),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(formatNumber)(_ctx.gift.requiredPoint)), 1)
      ]),
      _createTextVNode(),
      _createVNode(AppButton, {
        variant: "primary",
        size: "sm",
        disabled: !canExchange.value,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('click', _ctx.gift)))
      }, {
        default: _withCtx(() => [
          _createTextVNode("交換する")
        ], undefined, true),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})